import { serieInitialData } from '@/constants/graphics';

const SET_GRAPHICS = 'SET_GRAPHICS';
const SET_SERIES = 'SET_SERIES';

const defaultState = {
    graphics: [],
};

const actions = {
    async getGraphics({ commit }, siteId) {
        const { data: { graphics } } = await this.$rq.getGraphics(siteId);
        commit(SET_GRAPHICS, graphics);
    },
    setSeries({ commit }, payload) {
        const { id, series } = payload;
        commit(SET_SERIES, { id, series });
    },
    async addGraphic({ dispatch }, payload) {
        const { siteId, graphic } = payload;
        await this.$rq.addGraphic(siteId, graphic);
        dispatch('getGraphics', siteId);
    },

    async editGraphic({ dispatch }, payload) {
        const { siteId, graphicId, graphic } = payload;
        await this.$rq.editGraphic(siteId, graphicId, graphic);
        dispatch('getGraphics', siteId);
    },

    async deleteGraphic({ dispatch }, payload) {
        const { siteId, graphicId } = payload;
        await this.$rq.deleteGraphic(siteId, graphicId);
        dispatch('getGraphics', siteId);
    },

    async resetAllGraphicSeries(_, payload) {
        const { siteId, graphicId } = payload;
        const getSeries = await this.$rq.getSeries(siteId, graphicId);
        const { data: { series } } = getSeries;
        await Promise.all(
            [series.map(({ id }) => this.$rq.updateSerie(siteId, graphicId, id, serieInitialData))],
        );
    },
};

const mutations = {
    SET_GRAPHICS(state, graphics) {
        state.graphics = graphics;
    },
    SET_SERIES(state, payload) {
        const { id, series } = payload;
        const indexId = state.graphics.findIndex(({ id: ghraphicId }) => id === ghraphicId);
        state.graphics[indexId].series = series;
    },
};

const getters = {
    graphics: state => state.graphics,
    getGraphic: state => graphicId => {
        const graphicIndex = state.graphics.findIndex(({ id }) => id === graphicId);
        return state.graphics[graphicIndex];
    },
    getSeries: state => graphicId => {
        const graphicIndex = state.graphics.findIndex(({ id }) => id === graphicId);
        return state.graphics[graphicIndex].series;
    },
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
